import { createContext } from "react";
import openSocket from "socket.io-client";
import { normalizeJwtToken } from "../../utils/normalizeJwtToken";
// import config from "../../services/config";

const socketManager = {
	currentSocket: null,

	GetSocket: function () {
		// ✅ CORREÇÃO: Tentar token JWT primeiro, depois public-token
		let rawToken = localStorage.getItem('token');
		
		// Se não tiver token JWT, tentar public-token
		if (!rawToken) {
			rawToken = localStorage.getItem("public-token");
		}
		
		// ✅ CORREÇÃO: Normalizar token (remove aspas, Bearer, etc)
		const token = normalizeJwtToken(rawToken);

		if (token !== this.currentToken) {
			if (this.currentSocket) {
				this.currentSocket.disconnect();
			}

			this.currentToken = token;
			const socketOptions = {
				transports: ["websocket"],
				pingTimeout: 18000,
				pingInterval: 18000,
				query: token ? { token: token } : {}
			};
			
			// ✅ Adicionar auth também (robustez)
			if (token) {
				socketOptions.auth = { token: token };
			}
			
			this.currentSocket = openSocket(process.env.REACT_APP_BACKEND_URL, socketOptions);
			
			// ✅ DIAGNÓSTICO: Logs (somente em desenvolvimento)
			if (process.env.NODE_ENV !== 'production') {
				this.currentSocket.on("connect", () => {
					console.debug("[SOCKET] SocketContext connected", {
						tokenLength: token?.length || 0,
						hasBearerPrefix: false, // Já removido
						event: "socket.connected"
					});
				});
				
				this.currentSocket.on("disconnect", (reason) => {
					console.debug("[SOCKET] SocketContext disconnected", {
						reason,
						event: "socket.disconnected"
					});
				});
			}
		}
		return this.currentSocket;
	},

	onConnect: function (callbackConnect) {
		if (this.currentSocket && this.currentSocket.connected) {
			callbackConnect();
		}
		this.currentSocket.on("connect", callbackConnect);
	},
};

const SocketContext = createContext()

export { SocketContext, socketManager };
